import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "src/app/store/base.graphql";

const uploadableFormAttachmentFields = `
id
attachmentUniqueId
attachmentTitle
attachmentIsMandatory
`;

export const CREATE_UPLOADABLE_FORM_ATTACHMENT = gql`
  mutation CreateServiceUploadableFormAttachmentMutation($input: ServiceUploadableFormAttachmentInputObject!) {
    createServiceUploadableFormAttachmentMutation(input: $input) {
      response {
        id
        status
        code
        message
      }
      data {
        ${uploadableFormAttachmentFields}
      }
    }
  }
`;

export const UPDATE_UPLOADABLE_FORM_ATTACHMENT = gql`
  mutation UpdateServiceUploadableFormAttachmentMutation($input: ServiceUploadableFormAttachmentInputObject!) {
    updateServiceUploadableFormAttachmentMutation(input: $input) {
      data{
        ${uploadableFormAttachmentFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const GET_SERVICE_UPLOADABLE_FORM_ATTACHMENT = gql`
  query GetServiceUploadableFormAttachment($formUniqueId: String) {
    getServiceUploadableFormAttachment(formUniqueId: $formUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${uploadableFormAttachmentFields}
      }
    }
  }
`;

export const DELETE_UPLOADABLE_FORM_ATTACHMENT = gql`
  mutation DeleteServiceUploadableFormAttachmentMutation($attachmentUniqueId: String!) {
    deleteServiceUploadableFormAttachmentMutation(attachmentUniqueId: $attachmentUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`
// CITIZEN

export const CITIZEN_GET_SERVICE_UPLOADABLE_FORM_ATTACHMENT = gql`
  query CitizenGetServiceUploadableFormAttachment($formUniqueId: String) {
    citizenGetServiceUploadableFormAttachment(formUniqueId: $formUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${uploadableFormAttachmentFields}
      }
    }
  }
`;

